(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-showcase')) {
    class VideoShowcase extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cs-vs-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.querySelectorAll('[data-cs-vs-slide]'));
        this.prevBtn = this.querySelector('[data-cs-vs-prev]');
        this.nextBtn = this.querySelector('[data-cs-vs-next]');
        this.dotsWrap = this.querySelector('[data-cs-vs-dots]');
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.initCarousel();
        this.initVideos();
        this.initAutoAdvance();
      }

      /* ---------- carousel ---------- */
      initCarousel() {
        this.onPrev = () => { this.userAct(); this.step(-1); };
        this.onNext = () => { this.userAct(); this.step(1); };
        if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
        this.onKey = (e) => {
          if (e.target !== this.track) return;
          if (e.key === 'ArrowRight') { e.preventDefault(); this.userAct(); this.step(1); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); this.userAct(); this.step(-1); }
          else if (e.key === 'Home') { e.preventDefault(); this.userAct(); this.goTo(0); }
          else if (e.key === 'End') { e.preventDefault(); this.userAct(); this.goTo(this.positions.length - 1); }
        };
        this.track.addEventListener('keydown', this.onKey);
        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => { this.raf = null; this.update(); });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.onResize = () => { this.measure(); this.update(); };
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.onResize);
          this.ro.observe(this.track);
        } else {
          window.addEventListener('resize', this.onResize);
        }
        this.onBlockSelect = (e) => {
          const i = this.slides.findIndex((sl) => sl.contains(e.target));
          if (i > -1) { this.paused = true; this.goToSlide(i); }
        };
        this.onBlockDeselect = () => { this.paused = false; };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.measure();
        this.update();
      }
      maxScroll() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }
      slideLeft(sl) { return sl.offsetLeft - this.slides[0].offsetLeft; }
      measure() {
        if (!this.slides.length) { this.positions = [0]; return; }
        const max = this.maxScroll();
        const pos = [];
        this.slides.forEach((sl) => {
          const x = Math.min(this.slideLeft(sl), max);
          if (!pos.length || x - pos[pos.length - 1] > 2) pos.push(x);
        });
        if (max - pos[pos.length - 1] > 2) pos.push(max);
        this.positions = pos;
        this.classList.toggle('is-static', max <= 2);
        this.renderDots();
      }
      renderDots() {
        if (!this.dotsWrap) return;
        const n = this.positions.length;
        if (this.dotsWrap.childElementCount === n) return;
        this.dotsWrap.innerHTML = '';
        if (n < 2) return;
        for (let i = 0; i < n; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'cs-video-showcase__dot';
          b.setAttribute('aria-label', 'Go to video ' + (i + 1) + ' of ' + n);
          b.addEventListener('click', () => { this.userAct(); this.goTo(i); });
          this.dotsWrap.appendChild(b);
        }
      }
      currentIndex() {
        const x = this.track.scrollLeft;
        let best = 0; let d = Infinity;
        this.positions.forEach((p, i) => { const dd = Math.abs(p - x); if (dd < d) { d = dd; best = i; } });
        return best;
      }
      update() {
        const x = this.track.scrollLeft;
        const max = this.maxScroll();
        if (this.prevBtn) this.prevBtn.disabled = x <= 2;
        if (this.nextBtn) this.nextBtn.disabled = x >= max - 2;
        if (this.dotsWrap) {
          const cur = this.currentIndex();
          Array.from(this.dotsWrap.children).forEach((b, i) => b.setAttribute('aria-current', i === cur ? 'true' : 'false'));
        }
      }
      scrollToX(x) {
        this.track.scrollTo({ left: x, behavior: this.reduce ? 'auto' : 'smooth' });
      }
      goTo(i) {
        if (!this.positions) return;
        const idx = Math.max(0, Math.min(this.positions.length - 1, i));
        this.scrollToX(this.positions[idx]);
      }
      goToSlide(i) {
        const sl = this.slides[i];
        if (sl) this.scrollToX(Math.min(this.slideLeft(sl), this.maxScroll()));
      }
      step(dir) {
        this.measure();
        const x = this.track.scrollLeft;
        let target;
        if (dir > 0) target = this.positions.find((p) => p > x + 2);
        else target = [...this.positions].reverse().find((p) => p < x - 2);
        if (target === undefined) target = dir > 0 ? this.maxScroll() : 0;
        this.scrollToX(target);
      }

      /* ---------- video playback ---------- */
      initVideos() {
        this.videos = Array.from(this.querySelectorAll('video'));
        if (!this.videos.length) return;
        this.auto = this.dataset.autoplay === 'true' && !this.reduce;
        this.videos.forEach((v) => {
          v.muted = true;
          v.setAttribute('muted', '');
          v.setAttribute('playsinline', '');
          const btn = v.parentElement.querySelector('[data-cs-vs-play]');
          if (!this.auto) {
            v.removeAttribute('autoplay');
            if (btn) {
              btn.hidden = false;
              btn.addEventListener('click', () => {
                btn.hidden = true;
                v.controls = true;
                const p = v.play();
                if (p && p.catch) p.catch(() => {});
              });
              v.addEventListener('pause', () => { if (!v.controls) btn.hidden = false; });
            } else {
              v.controls = true;
            }
          }
        });
        if (!('IntersectionObserver' in window)) return;
        /* Root = viewport. Intersection is clipped by the overflow track, so a video counts as
           visible only when it is on screen AND inside the carousel window (peeking slides don't play). */
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            const v = e.target;
            const visible = e.isIntersecting && e.intersectionRatio >= 0.6 && !document.hidden;
            v.dataset.visible = visible ? '1' : '0';
            if (visible) {
              if (this.auto) {
                const p = v.play();
                if (p && p.catch) p.catch(() => { v.controls = true; });
              }
            } else if (!v.paused) {
              v.pause();
            }
          });
        }, { threshold: [0, 0.3, 0.6, 0.9] });
        this.videos.forEach((v) => this.observer.observe(v));
        this.onVis = () => {
          if (document.hidden) { this.videos.forEach((v) => v.pause()); return; }
          if (this.auto) this.videos.forEach((v) => {
            if (v.dataset.visible === '1') { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
          });
        };
        document.addEventListener('visibilitychange', this.onVis);
      }

      /* ---------- optional auto-advance (off by default) ---------- */
      initAutoAdvance() {
        if (this.dataset.autoAdvance !== 'true' || this.reduce || this.slides.length < 2) return;
        const ms = Math.max(2, parseInt(this.dataset.autoAdvanceSpeed, 10) || 5) * 1000;
        this.inView = false;
        this.onEnter = () => { this.hovering = true; };
        this.onLeave = () => { this.hovering = false; };
        this.addEventListener('pointerenter', this.onEnter);
        this.addEventListener('pointerleave', this.onLeave);
        if ('IntersectionObserver' in window) {
          this.sectionObs = new IntersectionObserver((en) => { this.inView = en[0].isIntersecting; }, { threshold: 0.25 });
          this.sectionObs.observe(this);
        } else { this.inView = true; }
        this.timer = setInterval(() => {
          if (this.paused || this.hovering || !this.inView || document.hidden || this.contains(document.activeElement) || Date.now() - (this.lastAct || 0) < ms) return;
          if (this.track.scrollLeft >= this.maxScroll() - 2) this.scrollToX(0);
          else this.step(1);
        }, ms);
      }
      userAct() { this.lastAct = Date.now(); }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.sectionObs) this.sectionObs.disconnect();
        if (this.ro) this.ro.disconnect(); else if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.onVis) document.removeEventListener('visibilitychange', this.onVis);
        if (this.timer) clearInterval(this.timer);
        if (this.raf) cancelAnimationFrame(this.raf);
      }
    }
    customElements.define('video-showcase', VideoShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
